import { Stack, SvgIconProps, Button, SvgIcon } from "@mui/material";
import TableFilters from "layout/TableConstructor/components/Filters";
import Table from "layout/TableConstructor/components/TableView";
import { useForm } from "react-hook-form";
import { FilterForm, Identifiable, TableConstructorProps, TableQueryVariables } from "layout/TableConstructor/types";
import { INPUT_DEFAULT_VALUE, InputType } from "components/generators/inputsGenerator";
import { useTableConstructor } from "layout/TableConstructor/context/tableConstructorContext";
import { useEffect, useMemo, useState } from "react";
import ColumnSettingsModal from "layout/TableConstructor/components/components/ColumnSettingsModal";
import useList from "hooks/useList";
import { generateFilterQuery } from "components/generators/filtersGenerator";
import { useSearchParams } from "react-router-dom";
import qs from "qs";
import _, { set } from "lodash";
import { OrderType } from "@generated/graphql";
import { LoadingButton, TabContext } from "@mui/lab";
import CircularLoading from "components/CircularLoading";
import TabList from "layout/TabLayout/components/TabList";
import useGetXlsxList from "./hooks/useGetXlsxList";

const CarbonIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'>
      <path
        d='M20.249 13.07V11.9225L21.689 10.6625C21.9544 10.4285 22.1286 10.1083 22.1808 9.7583C22.2329 9.40833 22.1597 9.05119 21.974 8.75L20.204 5.75C20.0724 5.5222 19.8833 5.33299 19.6556 5.20135C19.4279 5.06971 19.1695 5.00027 18.9065 5C18.7435 4.99875 18.5813 5.02408 18.4265 5.075L16.604 5.69C16.2897 5.48022 15.9615 5.29228 15.6215 5.1275L15.239 3.2375C15.1704 2.8922 14.9825 2.58203 14.7083 2.36128C14.4341 2.14052 14.0909 2.02325 13.739 2.03H10.229C9.87699 2.02325 9.53386 2.14052 9.25963 2.36128C8.9854 2.58203 8.79755 2.8922 8.72897 3.2375L8.34647 5.1275C8.00444 5.29299 7.67372 5.4809 7.35647 5.69L5.57147 5.045C5.41494 5.00422 5.25285 4.98902 5.09147 5C4.82842 5.00027 4.57008 5.06971 4.34234 5.20135C4.11461 5.33299 3.92549 5.5222 3.79397 5.75L2.02397 8.75C1.84891 9.05074 1.78386 9.40299 1.83996 9.74642C1.89605 10.0899 2.06981 10.4031 2.33147 10.6325L3.74897 11.93V13.0775L2.33147 14.3375C2.06242 14.5685 1.88391 14.8873 1.82762 15.2375C1.77133 15.5876 1.84089 15.9463 2.02397 16.25L3.79397 19.25C3.92549 19.4778 4.11461 19.667 4.34234 19.7987C4.57008 19.9303 4.82842 19.9997 5.09147 20C5.25448 20.0012 5.41661 19.9759 5.57147 19.925L7.39397 19.31C7.7082 19.5198 8.03648 19.7077 8.37647 19.8725L8.75897 21.7625C8.82755 22.1078 9.0154 22.418 9.28963 22.6387C9.56386 22.8595 9.90699 22.9767 10.259 22.97H13.799C14.1509 22.9767 14.4941 22.8595 14.7683 22.6387C15.0425 22.418 15.2304 22.1078 15.299 21.7625L15.6815 19.8725C16.0235 19.707 16.3542 19.5191 16.6715 19.31L18.4865 19.925C18.6413 19.9759 18.8035 20.0012 18.9665 20C19.2295 19.9997 19.4879 19.9303 19.7156 19.7987C19.9433 19.667 20.1324 19.4778 20.264 19.25L21.974 16.25C22.149 15.9493 22.2141 15.597 22.158 15.2536C22.1019 14.9101 21.9281 14.5969 21.6665 14.3675L20.249 13.07ZM18.9065 18.5L16.334 17.63C15.7314 18.1396 15.0432 18.5382 14.3015 18.8075L13.769 21.5H10.229L9.69647 18.8375C8.96053 18.5607 8.27608 18.1627 7.67147 17.66L5.09147 18.5L3.32147 15.5L5.36147 13.7C5.22279 12.9236 5.22279 12.1289 5.36147 11.3525L3.32147 9.5L5.09147 6.5L7.66397 7.37C8.26654 6.86044 8.95469 6.46177 9.69647 6.1925L10.229 3.5H13.769L14.3015 6.1625C15.0374 6.43933 15.7219 6.83732 16.3265 7.34L18.9065 6.5L20.6765 9.5L18.6365 11.3C18.7751 12.0764 18.7751 12.8711 18.6365 13.6475L20.6765 15.5L18.9065 18.5Z' // eslint-disable-line max-len
        fill='currentColor'
      />
      <path
        d='M11.9991 17C11.1091 17 10.2391 16.7361 9.49908 16.2416C8.75906 15.7471 8.18228 15.0443 7.84169 14.2221C7.5011 13.3998 7.41198 12.495 7.58561 11.6221C7.75925 10.7492 8.18783 9.94736 8.81717 9.31802C9.4465 8.68868 10.2483 8.2601 11.1212 8.08647C11.9942 7.91283 12.899 8.00195 13.7212 8.34254C14.5435 8.68314 15.2463 9.25991 15.7408 9.99993C16.2352 10.74 16.4991 11.61 16.4991 12.5C16.5052 13.0926 16.3929 13.6805 16.1689 14.2292C15.9448 14.7779 15.6136 15.2763 15.1945 15.6954C14.7755 16.1145 14.277 16.4457 13.7283 16.6697C13.1796 16.8937 12.5918 17.006 11.9991 17ZM11.9991 9.5C11.6027 9.49076 11.2084 9.56205 10.8403 9.70954C10.4721 9.85704 10.1377 10.0777 9.85726 10.3581C9.57682 10.6386 9.35618 10.973 9.20869 11.3411C9.0612 11.7093 8.98991 12.1035 8.99915 12.5C8.98991 12.8965 9.0612 13.2907 9.20869 13.6589C9.35618 14.027 9.57682 14.3614 9.85726 14.6419C10.1377 14.9223 10.4721 15.143 10.8403 15.2905C11.2084 15.438 11.6027 15.5092 11.9991 15.5C12.3956 15.5092 12.7899 15.438 13.158 15.2905C13.5262 15.143 13.8606 14.9223 14.141 14.6419C14.4215 14.3614 14.6421 14.027 14.7896 13.6589C14.9371 13.2907 15.0084 12.8965 14.9991 12.5C15.0084 12.1035 14.9371 11.7093 14.7896 11.3411C14.6421 10.973 14.4215 10.6386 14.141 10.3581C13.8606 10.0777 13.5262 9.85704 13.158 9.70954C12.7899 9.56205 12.3956 9.49076 11.9991 9.5Z' // eslint-disable-line max-len
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2313 1.78H13.7367C14.1464 1.77273 14.5458 1.90951 14.8651 2.16654C15.1849 2.42397 15.404 2.78564 15.4841 3.18827C15.484 3.18809 15.4841 3.18844 15.4841 3.18827L15.8422 4.95766C16.116 5.09535 16.3821 5.24774 16.6394 5.41418L18.3465 4.83812L18.3484 4.83751C18.5288 4.77819 18.7177 4.74864 18.9076 4.75C19.2142 4.75046 19.5153 4.83147 19.7807 4.9849C20.0461 5.13829 20.2665 5.35869 20.4199 5.62402C20.4201 5.62435 20.4203 5.62467 20.4205 5.625L22.1881 8.62093C22.4038 8.97187 22.4887 9.38768 22.428 9.79515C22.3672 10.2034 22.164 10.5771 21.8543 10.85L20.499 12.0359V12.9599L21.8333 14.1813C22.1375 14.4488 22.3394 14.8135 22.4047 15.2133C22.4701 15.6136 22.3944 16.0241 22.1906 16.3748C22.1904 16.3751 22.1902 16.3754 22.19 16.3758L20.4812 19.3738L20.4805 19.375C20.327 19.6408 20.1064 19.8615 19.8407 20.0151C19.5753 20.1685 19.2742 20.2495 18.9676 20.25C18.7777 20.2514 18.5888 20.2218 18.4084 20.1625L18.4062 20.1618L16.706 19.5857C16.4461 19.7518 16.1778 19.9043 15.9021 20.0425L15.5442 21.8112C15.5441 21.8114 15.5442 21.811 15.5442 21.8112C15.4641 22.2139 15.2449 22.576 14.9251 22.8335C14.6058 23.0905 14.2064 23.2273 13.7967 23.22H10.2613C9.85151 23.2273 9.45215 23.0905 9.13286 22.8335C8.81306 22.576 8.59395 22.2143 8.51385 21.8117C8.51382 21.8115 8.51389 21.8118 8.51385 21.8117L8.15577 20.0423C7.88198 19.9047 7.61583 19.7523 7.35849 19.5858L5.6514 20.1619L5.64955 20.1625C5.46917 20.2218 5.28033 20.2514 5.09046 20.25C4.78383 20.2496 4.4827 20.1686 4.21723 20.0151C3.95188 19.8617 3.73148 19.6413 3.57806 19.376C3.57786 19.3757 3.57766 19.3753 3.57746 19.375L1.80986 16.3791C1.80965 16.3787 1.80944 16.3784 1.80923 16.378C1.59611 16.0239 1.51518 15.6058 1.58079 15.1978C1.64634 14.7901 1.85397 14.4187 2.1669 14.1493L3.49897 12.9652V12.0401L2.16458 10.8187C1.86047 10.5512 1.65853 10.1865 1.59323 9.78673C1.52778 9.38606 1.60367 8.9751 1.80791 8.62423L1.80865 8.62296L3.57808 5.62393C3.7315 5.35864 3.9519 5.13828 4.21723 4.9849C4.48051 4.83272 4.77885 4.75179 5.08285 4.75003C5.26836 4.7383 5.45458 4.7562 5.6345 4.80308L5.64562 4.80597L7.32459 5.41266C7.5836 5.24717 7.85103 5.09525 8.1258 4.95751L8.48376 3.1888C8.48373 3.18897 8.48379 3.18862 8.48376 3.1888C8.56386 2.78616 8.78307 2.42397 9.10286 2.16654C9.42215 1.90951 9.8215 1.77273 10.2313 1.78ZM10.2242 2.27995C9.93087 2.27433 9.64492 2.37206 9.4164 2.55602C9.18787 2.73998 9.03133 2.99846 8.97418 3.2862L8.56692 5.29856L8.45535 5.35254C8.12324 5.51323 7.8021 5.6957 7.49405 5.89874L7.38939 5.96772L5.49781 5.2842C5.37067 5.25227 5.23927 5.24052 5.10844 5.24942L5.10009 5.24999L5.09173 5.25C4.87252 5.25022 4.65723 5.30809 4.46745 5.41779C4.27767 5.52749 4.12008 5.68516 4.01048 5.875L4.0093 5.87704L2.24003 8.87577C2.23991 8.87597 2.24015 8.87556 2.24003 8.87577C2.09441 9.12625 2.03998 9.42016 2.08669 9.70612C2.13343 9.99231 2.27823 10.2533 2.49628 10.4445L2.50031 10.448L3.99897 11.8199V13.1898L2.49435 14.5272C2.27014 14.7197 2.12136 14.9854 2.07445 15.2771C2.02754 15.5689 2.08551 15.8679 2.23807 16.1209L2.2393 16.123L4.01049 19.125C4.12008 19.3148 4.27767 19.4725 4.46745 19.5822C4.65723 19.6919 4.87252 19.7498 5.09173 19.75L5.09338 19.75C5.22893 19.751 5.36373 19.73 5.49252 19.6878C5.49223 19.6879 5.49281 19.6877 5.49252 19.6878L7.43052 19.0338L7.53278 19.1021C7.83749 19.3055 8.15581 19.4877 8.4855 19.6475L8.59694 19.7015L9.004 21.7129C9.06115 22.0007 9.21787 22.26 9.4464 22.444C9.67492 22.6279 9.96087 22.7257 10.2542 22.72L10.259 22.72L13.8038 22.72C14.0971 22.7256 14.383 22.6279 14.6115 22.444C14.8401 22.26 14.9966 22.0015 15.0538 21.7138L15.461 19.7014L15.5726 19.6475C15.9047 19.4868 16.2258 19.3043 16.5339 19.1013L16.6359 19.034L18.5646 19.6875C18.5642 19.6874 18.5649 19.6876 18.5646 19.6875C18.6933 19.7297 18.829 19.751 18.9646 19.75L18.9662 19.75C19.1854 19.7498 19.4007 19.6919 19.5905 19.5822C19.7801 19.4726 19.9377 19.315 20.0472 19.1254C20.0472 19.1255 20.0473 19.1252 20.0472 19.1254L21.7568 16.1262L21.7579 16.1242C21.9038 15.8736 21.958 15.5801 21.9113 15.2939C21.8645 15.0077 21.7197 14.7467 21.5017 14.5555L21.4976 14.552L19.999 13.1801V11.8091L21.5237 10.475C21.5235 10.4751 21.5238 10.4748 21.5237 10.475C21.7446 10.28 21.8901 10.0129 21.9335 9.72145C21.9769 9.42981 21.9159 9.13219 21.7612 8.8812L21.7586 8.87706L19.9887 5.87704L19.9875 5.875C19.8779 5.68516 19.7203 5.52749 19.5305 5.41779C19.3407 5.30809 19.1254 5.25022 18.9062 5.25L18.9046 5.24999C18.769 5.24895 18.6342 5.26997 18.5054 5.31221C18.5051 5.3123 18.5057 5.31211 18.5054 5.31221L16.5674 5.96619L16.4652 5.89793C16.1605 5.69451 15.8421 5.51226 15.5124 5.35247L15.401 5.29846L14.9939 3.28709C14.9368 2.99934 14.7801 2.73998 14.5515 2.55602C14.323 2.37206 14.0371 2.27433 13.7438 2.27995L13.739 2.28005L10.2242 2.27995ZM10.0236 3.25H13.9739L14.5197 5.97892C15.1894 6.24554 15.8158 6.60988 16.3787 7.06006L19.0198 6.20017L20.9967 9.55083L18.906 11.3956C19.0187 12.1107 19.0186 12.8391 18.9057 13.5543L20.9952 15.4517L19.0186 18.8018L16.386 17.9115C15.8242 18.3672 15.1944 18.732 14.5197 18.9927L13.9744 21.75H10.024L9.47824 19.0211C8.80858 18.7545 8.1821 18.3901 7.61919 17.9399L4.9781 18.7998L3.00121 15.4492L5.09191 13.6044C4.97919 12.8893 4.97931 12.1609 5.09228 11.4457L3.00273 9.54825L4.97929 6.19815L7.61195 7.0885C8.17376 6.63284 8.8035 6.26801 9.47826 6.0073L10.0236 3.25ZM10.4344 3.75L9.91436 6.37937L9.78178 6.4275C9.06778 6.68668 8.4054 7.07042 7.8254 7.56089L7.71761 7.65205L5.20365 6.80185L3.64021 9.45175L5.63188 11.2604L5.60757 11.3965C5.47409 12.1437 5.47409 12.9088 5.60757 13.656L5.6323 13.7944L3.64173 15.5508L5.20484 18.2002L7.72523 17.3796L7.8313 17.4678C8.41447 17.9526 9.07465 18.3365 9.78449 18.6035L9.9144 18.6524L10.4339 21.25H13.5636L14.0836 18.6206L14.2162 18.5725C14.9302 18.3133 15.5925 17.9296 16.1725 17.4391L16.2803 17.348L18.7943 18.1982L20.3577 15.5483L18.3661 13.7396L18.3904 13.6035C18.5238 12.8563 18.5238 12.0912 18.3904 11.344L18.3656 11.2056L20.3562 9.44917L18.7931 6.79983L16.2727 7.62042L16.1666 7.53224C15.5835 7.04739 14.9233 6.66351 14.2135 6.39649L14.0835 6.34763L13.564 3.75H10.4344ZM13.6256 8.57351C12.849 8.25184 11.9944 8.16768 11.17 8.33166C10.3456 8.49565 9.58832 8.90042 8.99394 9.4948C8.39957 10.0892 7.9948 10.8464 7.83081 11.6709C7.66682 12.4953 7.75099 13.3498 8.07266 14.1264C8.39433 14.903 8.93907 15.5667 9.63797 16.0337C10.3369 16.5007 11.1586 16.75 11.9991 16.75H12.0017C12.5611 16.7557 13.1159 16.6497 13.6338 16.4383C14.1517 16.2268 14.6222 15.9142 15.0178 15.5186C15.4133 15.1231 15.726 14.6526 15.9374 14.1347C16.1489 13.6168 16.2548 13.0619 16.2492 12.5025L16.2491 12.5C16.2491 11.6594 15.9999 10.8377 15.5329 10.1388C15.0659 9.43992 14.4021 8.89518 13.6256 8.57351ZM11.0725 7.84127C11.9939 7.65799 12.9489 7.75206 13.8169 8.11157C14.6848 8.47109 15.4267 9.07991 15.9486 9.86104C16.4703 10.6418 16.7489 11.5597 16.7491 12.4987C16.7553 13.1242 16.6367 13.7446 16.4003 14.3237C16.1637 14.9031 15.8139 15.4296 15.3713 15.8722C14.9287 16.3148 14.4023 16.6646 13.8228 16.9012C13.2437 17.1376 12.6234 17.2562 11.9979 17.25C11.0589 17.2498 10.141 16.9712 9.36019 16.4495C8.57906 15.9275 7.97024 15.1857 7.61072 14.3177C7.2512 13.4498 7.15714 12.4947 7.34042 11.5733C7.5237 10.6519 7.97609 9.80554 8.64039 9.14124C9.30469 8.47694 10.1511 8.02455 11.0725 7.84127ZM11.9991 9.24994C12.4275 9.24074 12.8533 9.31813 13.251 9.47747C13.6505 9.63754 14.0135 9.87699 14.3178 10.1813C14.6222 10.4857 14.8616 10.8486 15.0217 11.2481C15.181 11.6459 15.2584 12.0717 15.2492 12.5C15.2584 12.9283 15.181 13.3541 15.0217 13.7519C14.8616 14.1514 14.6222 14.5143 14.3178 14.8187C14.0135 15.123 13.6505 15.3625 13.251 15.5225C12.8533 15.6819 12.4275 15.7593 11.9991 15.7501C11.5708 15.7593 11.145 15.6819 10.7473 15.5225C10.3477 15.3625 9.98483 15.123 9.68048 14.8187C9.37614 14.5143 9.13669 14.1514 8.97662 13.7519C8.81728 13.3541 8.73989 12.9283 8.74909 12.5C8.73989 12.0717 8.81728 11.6459 8.97662 11.2481C9.13669 10.8486 9.37614 10.4857 9.68048 10.1813C9.98483 9.87699 10.3477 9.63754 10.7473 9.47747C11.145 9.31813 11.5708 9.24074 11.9991 9.24994ZM11.9933 9.74993C11.6306 9.74148 11.27 9.80669 10.9332 9.94161C10.5965 10.0765 10.2906 10.2784 10.034 10.5349C9.77751 10.7914 9.57568 11.0973 9.44076 11.4341C9.30584 11.7709 9.24063 12.1315 9.24908 12.4942L9.24935 12.5058C9.2409 12.8685 9.30584 13.2291 9.44076 13.5659C9.57568 13.9027 9.77751 14.2086 10.034 14.4651C10.2906 14.7216 10.5965 14.9235 10.9332 15.0584C11.27 15.1933 11.6306 15.2585 11.9933 15.2501L12.005 15.2498C12.3677 15.2582 12.7283 15.1933 13.0651 15.0584C13.4018 14.9235 13.7077 14.7216 13.9643 14.4651C14.2208 14.2086 14.4226 13.9027 14.5575 13.5659C14.6925 13.2291 14.7577 12.8685 14.7492 12.5058L14.7489 12.4942C14.7574 12.1315 14.6925 11.7709 14.5575 11.4341C14.4226 11.0973 14.2208 10.7914 13.9643 10.5349C13.7077 10.2784 13.4018 10.0765 13.0651 9.94161C12.7283 9.80669 12.3677 9.74148 12.005 9.74993H11.9933Z' // eslint-disable-line max-len
        fill='currentColor'
      />
    </svg>
  </SvgIcon>
);

const View = <
  T extends Identifiable,
  AvailableFilters extends object,
  OrderField extends string,
  CollapsingRowName extends string | undefined = undefined,
>(
  props: TableConstructorProps<T, AvailableFilters, OrderField, CollapsingRowName>
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);
  const {
    data,
    filtersConfig,
    totalCount,
    loading,
    initialFetch,
    refetch,
    tabs,
    defaultTabId,
    emptyPlaceholderText,
    exportRoute,
    collapsingRowName,
    checkIsCollapsingRow,
    onRowClick,
    storageName,
    settingsModalTitle,
    permanentFilter,
    defaultOrder,
    renderControls,
  } = props;
  const { visibleFilterList, visibleFilterConfig, visibleColumnList } = useTableConstructor<
    T,
    AvailableFilters,
    OrderField
  >();
  const form = useForm<FilterForm<AvailableFilters>>({
    values: visibleFilterList.reduce((acc, currentFilterName) => {
      const input = filtersConfig.find((f) => f.name === currentFilterName);

      if (!input) return acc;

      const existingValue = _.get(query, input.name);

      const isAutocomplete = input.type === InputType.AUTOCOMPLETE;
      if (!isAutocomplete || (isAutocomplete && !input.multiple)) {
        const value = existingValue || INPUT_DEFAULT_VALUE[input.type];
        set(acc, currentFilterName, value);
      } else {
        set(acc, currentFilterName, existingValue || []);
      }
      return acc;
    }, {} as FilterForm<AvailableFilters>),
  });

  const { limit, page, params } = useList();
  const { tab: tabParam } = params as unknown as {
    tab?: string;
  };

  const [tabValue, setTab] = useState<string>(tabParam || defaultTabId || "1");

  const getOrder = () => {
    const { sortField, sortOrder } = params;
    let order = defaultOrder;
    if (sortOrder && sortField) {
      order = {
        order: sortOrder as OrderType,
        field: sortField as OrderField,
      };
    }
    return order;
  };

  const getFilter = () => {
    let filter = generateFilterQuery(visibleFilterConfig, params);
    if (permanentFilter) {
      filter = filter ? { ...filter, ...permanentFilter } : permanentFilter;
    }
    return filter;
  };

  const getTabFilter = () => {
    let filter = tabs?.find((tab) => tab.id === tabParam)?.filter;
    if (permanentFilter) {
      filter = filter ? { ...filter, ...permanentFilter } : permanentFilter;
    }
    return filter;
  };

  useEffect(() => {
    if (refetch || initialFetch) {
      const filter = getFilter();
      const order = getOrder();
      const tabFilter = getTabFilter();

      let variables: TableQueryVariables<OrderField>;

      if (tabParam && tabParam !== tabValue) {
        setTab(tabParam);

        variables = {
          page: 0,
          limit: Number(limit) || 50,
          filter: tabFilter || {},
          order: defaultOrder,
        };
      } else {
        variables = {
          page: page && Number(page) !== 0 ? Number(page) - 1 : 0,
          limit: Number(limit) || 50,
          filter: { ...(filter || {}), ...tabFilter },
          order,
        };
      }

      // initialFetch используется в связке с Apollo LazyQuery для предотвращения дублирования запросов
      if (initialFetch) {
        initialFetch({ variables });
      } else {
        refetch(variables);
      }
    }
  }, [params]);

  const [openFilterSettingModal, setOpenFilterSettingModal] = useState(false);
  const onClose = () => setOpenFilterSettingModal(false);
  const onOpen = () => setOpenFilterSettingModal(true);

  const { getXlsxListFile, isLoading } = useGetXlsxList();
  const onDownloadXlsxFile = () => {
    const order = getOrder();
    const filter = getFilter();
    if (exportRoute) {
      getXlsxListFile({ route: exportRoute, order, filter, columns: visibleColumnList });
    }
  };

  const handleChange = (newTabId: string) => {
    setSearchParams(qs.stringify({ tab: newTabId, limit }), { replace: tabParam === undefined });
    form.reset();
  };

  useEffect(() => {
    if (!tabParam && tabs?.length) {
      setSearchParams(
        qs.stringify({
          ...params,
          tab: tabValue,
        }),
        { replace: true }
      );
    }
  }, []);

  const currentTabEmptyPlaceholderText = useMemo(
    () => tabs?.find((tab) => tab.id === tabValue)?.emptyPlaceholderText || emptyPlaceholderText,
    [tabs, tabValue]
  );

  if (loading) return <CircularLoading />;

  return (
    <Stack spacing={1.5}>
      <TableFilters<T, AvailableFilters, OrderField> form={form} />
      <Stack
        spacing={1}
        direction='row'
        justifyContent='space-between'
        alignItems='flex-end'>
        {tabs?.length && (
          <TabContext value={tabValue}>
            <TabList
              tabs={tabs}
              onChange={handleChange}
            />
          </TabContext>
        )}
        <Stack
          spacing={1}
          direction='row'
          justifyContent='flex-end'
          sx={{ marginLeft: "auto !important" }}>
          {renderControls ? renderControls() : ""}
          {!!exportRoute && (
            <LoadingButton
              onClick={onDownloadXlsxFile}
              loading={isLoading}
              variant='contained'
              sx={{ backgroundColor: "#fff", color: "text.primary", "&:hover": { color: "#fff" } }}>
              Выгрузить таблицу
            </LoadingButton>
          )}
          <Button
            onClick={onOpen}
            sx={{ backgroundColor: "#fff", color: "primary.main", "&:hover .MuiSvgIcon-root": { color: "#fff" } }}
            variant='contained'>
            <CarbonIcon sx={{ color: "inherit" }} />
          </Button>
        </Stack>
      </Stack>
      <Table<T, AvailableFilters, OrderField, CollapsingRowName>
        data={data}
        totalCount={totalCount}
        emptyPlaceholderText={currentTabEmptyPlaceholderText}
        collapsingRowName={collapsingRowName}
        checkIsCollapsingRow={checkIsCollapsingRow}
        onRowClick={onRowClick}
      />
      {openFilterSettingModal && (
        <ColumnSettingsModal<T, AvailableFilters, OrderField>
          open={openFilterSettingModal}
          onClose={onClose}
          storageName={storageName}
          title={settingsModalTitle}
        />
      )}
    </Stack>
  );
};

export default View;
